export default __webpack_public_path__ + "static/media/Role_ee.dcf05141.png";